// .input-group下のパスワードフィールドの表示切替
// Usage: ボタンに'js-password-toggle'クラスを付けて、同じ.input-group内に配置する
// Optional: data-label-show / data-label-hide 属性でボタンの表示ラベルをカスタマイズ可能

function _setButtonState(button, isVisible) {
  var showLabel = button.getAttribute("data-label-show") || "表示";
  var hideLabel = button.getAttribute("data-label-hide") || "非表示";
  button.textContent = isVisible ? hideLabel : showLabel;
  // トグルボタンの現在状態をアクセシビリティ支援技術へ伝えるためのARIA属性
  button.setAttribute("aria-pressed", isVisible ? "true" : "false");
  button.setAttribute(
    "aria-label",
    isVisible ? "パスワードを非表示" : "パスワードを表示"
  );
}

function _toggleForButton(button) {
  var container = button.closest(".input-group");
  if (!container) return;
  var input = container.querySelector(
    'input[type="password"], input[type="text"]'
  );
  if (!input) return;

  var isVisible = input.type === "text";
  input.type = isVisible ? "password" : "text";
  _setButtonState(button, !isVisible);
}

function initPasswordToggles() {
  var buttons = Array.prototype.slice.call(
    document.querySelectorAll(".js-password-toggle")
  );
  buttons.forEach(function (btn) {
    var container = btn.closest(".input-group");
    var visible = false;
    if (container) {
      var input = container.querySelector(
        'input[type="password"], input[type="text"]'
      );
      if (input) visible = input.type === "text";
    }
    _setButtonState(btn, visible);

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      _toggleForButton(btn);
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initPasswordToggles();
});
